import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, RequiredValidator, Validators } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { PreCandidato } from 'src/app/models/preCandidato.model';
import { PreCandidatoCsvDTO } from 'src/app/models/preCandidatoCsvDTO.model';
import { PreCandidatosService } from 'src/app/services/precandidatos.service';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { CandidaturaService } from 'src/app/services/candidatura.service';
import { Utils } from 'src/app/utils/utils';
import { Pipe, PipeTransform } from '@angular/core';
import { Page } from 'src/app/models/page.model';

declare var window: any;
@Component({
  selector: 'app-precandidato',
  templateUrl: './precandidato.component.html',
  styleUrls: ['./precandidato.component.css']
})

export class PreCandidatoComponent implements OnInit {
  idEleicao: any;
  novoPreCandidato: any;
  formPreCadastroCandidato: FormGroup;
  editandoPreCandidato: boolean = false;
  token: any;
  idPreCandidatoEditando: any;
  idCandidatura: any;
  listaCargos: any[] = [];
  select: FormGroup;
  precandidatosArray: PreCandidatoCsvDTO[] = [];
  newPreCandidatosArray: PreCandidatoCsvDTO[] = [];
  listaPreCandidatos: PreCandidato[];
  btOff: boolean = false;
  list: any;
  public imageSrc: string = '';
  carregandoPreCandidatos: boolean;
  carregandoPreCandidatosEdit: boolean;
  votoJustificavel: boolean = false;
  parametroJustificativa: any;
  isSubmit: boolean = false;
  formModal: any;
  validaEmail: boolean = true;
  public page: Page;

  constructor(
    public eleicaoService: EleicaoService,
    public candidaturaService: CandidaturaService,
    public precanditadosService: PreCandidatosService,
    protected messageService: MessageService,
    public spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    public utils: Utils,
  ) { }

 async ngOnInit() {
    this.token = sessionStorage.getItem("token");
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.idCandidatura = await JSON.parse(sessionStorage.getItem("candidaturaId"));
    this.listarCargosEleicao();
    this.formPreCadastroCandidato = new FormGroup({
      nome: new FormControl(),
      emailPreCandidato: new FormControl(),
      cpf: new FormControl(),
      precandidatocurriculum: new FormControl(),
      votoJustificavel: new FormControl(),
      parametroJustificativa: new FormControl(),
      cargo: new FormControl(),
      formularioPreenchido: new FormControl(),
      login: new FormControl()
    });
    this.formPreCadastroCandidato = this.formBuilder.group({
      nome: [''],
      cpf: [null, this.isValidCPF],
      emailPreCandidato: [''],
      precandidatocurriculum: [''],
      votoJustificavel: ['false'],
      parametroJustificativa: [''],
      cargo: [''],
      formularioPreenchido: ['false'],
      login: ['', [Validators.required, this.utils.noWhitespaceValidator]]
    });

    this.novoPreCandidato = new PreCandidato;
    this.select = this.formBuilder.group({
      select: ['']
    });
    this.formModal = new window.bootstrap.Modal(
      document.getElementById('myModal3')
    );
    if(sessionStorage.getItem("temCandidaturas")){
    await this.dadosCandidaturaExistentes();
    this.buscarPreCandidatosPorCandidaturaIdPage(10, 0);
  }
  }

  public listarCargosEleicao() {
    this.eleicaoService.getCargosByIdEleicao(this.idEleicao, this.token).then((res: []) => {
      if (res != null && res.length > 0) {
        this.listaCargos = res;
        this.spinner.hide();
      } else {
        this.messageService.add({ key: 'toast', severity: 'info', summary: 'Informação', detail: 'Ainda não existem cargos cadastros para essa eleição' });
        this.spinner.hide();
      }
    })
  }
  
  // o submit chama a abertura do modal e as funçooes do sim ou não seguem com o envioCandidato

  validaCurriculo(){ // chamado no click do submit
    if (this.formPreCadastroCandidato.get("precandidatocurriculum").value == null || this.utils.noWhitespaceValidatorString2(this.formPreCadastroCandidato.get("precandidatocurriculum").value)) {
      this.formModal.show(); //se o campo curriculum estiver vazio, abre o modal com as opções
    } else {
      this.envioPreCandidato(); // se não estiver vazio, ele faz o envio/persistência
    }
  }
  prosseguirSemCurriculum() { //ao clicar em "SIM" no modal
    this.formModal.hide();
    this.envioPreCandidato(); // submete
  }
  pararSubmit() { // ao clicar "Não"
    this.formModal.hide();
    return false; // para aqui e não executa nenhuma ação
  }

  public envioPreCandidato() {    
    this.isSubmit = true;
    this.validarEmailPreCandidato(this.formPreCadastroCandidato.get('emailPreCandidato').value);
    if (!this.formPreCadastroCandidato.valid) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: "Corrija o(s) erro(s) apontado(s) no formulário!" })
    }
    else if (this.validaEmail == false) {
      return this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'Por favor preencha um Email válido para o precandidato' });
    }else{
    this.novoPreCandidato.votoJustificavel = this.formPreCadastroCandidato.get("votoJustificavel").value;
    this.novoPreCandidato.parametroJustificativa = this.formPreCadastroCandidato.get("votoJustificavel").value == 'true' ? this.formPreCadastroCandidato.get("parametroJustificativa").value : '';
    if (this.novoPreCandidato.votoJustificavel === 'true' && (this.novoPreCandidato.parametroJustificativa == null || this.novoPreCandidato.parametroJustificativa.trim() == '')) {
      return this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Atenção', detail: "É necessário preencher o campo parametro justificativa caso o voto seja justificável." })
    }
    
    this.novoPreCandidato.email = this.formPreCadastroCandidato.get("emailPreCandidato").value;
    this.novoPreCandidato.nome = this.formPreCadastroCandidato.get("nome").value;
    this.novoPreCandidato.cpf = this.formPreCadastroCandidato.get("cpf").value;
    this.novoPreCandidato.curriculum = this.formPreCadastroCandidato.get("precandidatocurriculum").value;
    this.novoPreCandidato.eleicao = { id: this.idEleicao };
    this.novoPreCandidato.imagem = this.imageSrc;
    this.novoPreCandidato.cargoId = this.formPreCadastroCandidato.get("cargo").value ;
    this.novoPreCandidato.candidatura = {"id": this.idCandidatura};
    this.novoPreCandidato.formularioPreenchido = this.formPreCadastroCandidato.get("formularioPreenchido").value;
    this.novoPreCandidato.login = this.formPreCadastroCandidato.get("login").value;
  }
    if (this.editandoPreCandidato == false) {
      this.btOff = true;
      document.body.style.cursor = 'wait';
      this.precanditadosService.cadastrarPreCandidato(this.novoPreCandidato, this.token).then(() => { //endpoint de criação.
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Pre Candidato criado com sucesso!' });
        this.btOff = false;
        document.body.style.cursor = 'default';
        this.fixAlterarImg(document.getElementById("imagePreCandidato"));
        this.formPreCadastroCandidato.reset();
        this.buscarPreCandidatosPorCandidaturaIdPage(10, 0);
        this.isSubmit = false;
      }, error => {
        this.btOff = false;
        document.body.style.cursor = 'default';
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
      })
    } else {
      this.precanditadosService.editarPreCandidato(this.novoPreCandidato, this.token, this.idPreCandidatoEditando).then(() => { //endpoint de edição.
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Precandidato editado com sucesso!' });
        this.fixAlterarImg(document.getElementById("imagePreCandidato"));
        this.formPreCadastroCandidato.reset();
        this.buscarPreCandidatosPorCandidaturaIdPage(10, 0);
        this.isSubmit = false;
        this.cancelarEdicao();
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
      })
    }
  }

 async listarPreCandidatosExistentes() {
    this.carregandoPreCandidatos = true;
   await this.precanditadosService.getPreCandidatosByIdEleicaoGestor(this.idCandidatura, this.token).then((res: []) => {
      if (res != null && res.length > 0) {
        this.listaPreCandidatos = res;
        this.spinner.hide();
        this.carregandoPreCandidatos = false;
      } else {
        this.listaPreCandidatos = [];// forçando zerando no front pra não continuar exibindo se a resposta zerar do back.
        this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Informação', detail: 'Ainda não existem precandidatos cadastrados para essa eleição' });
        this.carregandoPreCandidatos = false;
        this.spinner.hide();
      }
    })
  }

  changePage(event) {
    this.buscarPreCandidatosPorCandidaturaIdPage(event.size, event.page)
  }

  validarEmailPreCandidato(email: string) {
    const expressaoRegularEmail = /\S+@\S+\.\S+/;
    if(expressaoRegularEmail.test(email) == false && email != '' && email != null){
      this.validaEmail = false;
    }else{
      this.validaEmail = true;
    }
  }
  handleInputChange(e) {
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }
  _handleReaderLoaded(e) {
    let reader = e.target;
    this.imageSrc = reader.result;
  }

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '150px',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    uploadUrl: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadWithCredentials: false,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertVideo']
    ]
  };

  public editarPreCandidato(precandidato) {
    this.editandoPreCandidato = true;
    this.idPreCandidatoEditando = precandidato.id;
    this.carregandoPreCandidatosEdit = true;
    this.votoJustificavel = this.formPreCadastroCandidato.get('votoJustificavel').value;
    this.precanditadosService.getPreCandidadosById(precandidato.id, this.token).then((res: any) => {
      this.formPreCadastroCandidato.patchValue(res);
      this.formPreCadastroCandidato.get("emailPreCandidato").patchValue(res.email);
      this.formPreCadastroCandidato.get("precandidatocurriculum").patchValue(res.curriculum);
      this.formPreCadastroCandidato.get("cargo").patchValue(res.cargoId);
      this.formPreCadastroCandidato.get("formularioPreenchido").patchValue(res.formularioPreenchido);
      this.formPreCadastroCandidato.get("login").patchValue(res.login);
      this.carregandoPreCandidatosEdit = false;
    }, err => {
      this.carregandoPreCandidatosEdit = false;
    })
    // this.imageSrc = candidato.imagem;
  }
  public cancelarEdicao() {
    this.editandoPreCandidato = false;
    this.formPreCadastroCandidato.reset();
  }
  public fixAlterarImg(input: any) {
    this.imageSrc = '';
    input.value = '';
  }
  public excluirPreCandidato(idPreCandidato) {
    this.btOff = true;
    document.body.style.cursor = 'wait';
    this.precanditadosService.excluirPreCandidatoEleicao(idPreCandidato, this.token).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Precandidato excluído da candidatura com sucesso!' });
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.buscarPreCandidatosPorCandidaturaIdPage(10, 0);
    }, err => {
      this.btOff = false;
      document.body.style.cursor = 'default';
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: err + '.' });
    })
  }

  baixarTemplate() {
    let csvHeader = 'nome;cpf;cargo;curriculo;votoJustificavel;parametrojustificativa;email;login;formularioPreenchido'
    this.utils.baixarModeloCsv(csvHeader, "precandidato")
  }

  isValidCPF(control: FormControl) {
    let cpf = (control.value || '');
    if (!cpf) {
      return null;
    }
    cpf = cpf.replace(/[^\d]+/g, '');
    if (cpf == '' || cpf.length != 11 ||
      cpf == "00000000000" ||
      cpf == "11111111111" ||
      cpf == "22222222222" ||
      cpf == "33333333333" ||
      cpf == "44444444444" ||
      cpf == "55555555555" ||
      cpf == "66666666666" ||
      cpf == "77777777777" ||
      cpf == "88888888888" ||
      cpf == "99999999999") {
      return { 'invalid': true };
    }
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(9))) {
      return { 'invalid': true };
    }

    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rest = (sum * 10) % 11;
    if (rest == 10 || rest == 11) {
      rest = 0;
    }
    if (rest != parseInt(cpf.charAt(10))) {
      return { 'invalid': true };
    }
    return null;
  }

  async dadosCandidaturaExistentes(){
    await this.candidaturaService.listarPorIdEleicao(this.idEleicao, this.token).then((data: any) => {
    this.idCandidatura = data.id;
    }, err => {
      console.log(err);
    })
  }

  buscarPreCandidatosPorCandidaturaIdPage(linesPerPage: number, page: number) {
    this.carregandoPreCandidatos = true;
    this.precanditadosService.findAllPreCandidatosByCandidaturaIdPage(this.idCandidatura, linesPerPage, page, '', this.token).then((res: any) => {
      if (res.content != null && res.content.length > 0) {
        this.listaPreCandidatos = res.content;
        this.page = res;
        this.spinner.hide();
        this.carregandoPreCandidatos = false;
      } else {
        this.listaPreCandidatos = [];// forçando zerando no front pra não continuar exibindo se a resposta zerar do back.
        this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Informação', detail: 'Ainda não existem precandidatos cadastrados para essa eleição' });
        this.carregandoPreCandidatos = false;
        this.spinner.hide();
      }
    })
  }

  public filtrarPreCandidatosPorNome(){
    var preCandidatoBuscado = (<HTMLInputElement>document.getElementById("filtroPreCandidato")).value;
    this.precanditadosService.findAllPreCandidatosByCandidaturaIdPage(this.idCandidatura, 10, 0, preCandidatoBuscado, this.token).then((res: any) => {
      if (res.content != null && res.content.length > 0) {
            this.page = res;
            this.listaPreCandidatos = res.content;
        } else {
          this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Ainda não existem pré-candidatos com esse login cadastrado.' });
          this.buscarPreCandidatosPorCandidaturaIdPage(10,0);
        }
    })
  }
  limparFiltro(){
    this.buscarPreCandidatosPorCandidaturaIdPage(10,0);
    (<HTMLInputElement>document.getElementById("filtroPreCandidato")).value = '';
  }

}
//Filtro para o nome do Cargo
@Pipe({
  name: 'cargoNome'
})
export class CargoNomePipe implements PipeTransform {
  transform(cargoId: number, listaCargos: any[]): string {
    const cargo = listaCargos.find(c => c.id === cargoId);
    return cargo ? cargo.nome : 'Sem cargo';
  }
}